import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
  Paper,
  Stack,
  Avatar,
} from '@mui/material';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as Location } from 'assets/icons/location.svg';
import { datacontext } from 'modules/AppLayout/AppLayout';
import FilesUploadPopup from './FilesUploadPopup';
import DocumentHistory from './DocumentHistory';
import { getApiCall } from 'api/apiService';
import { GET_FILE_MANAGER, DOCUMENT_TYPE_LIST } from 'constant/app.config';
import { useParams } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Loading from 'assets/images/loading.png';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import { poppins400, poppins500, poppins600 } from 'theme/common.style';
import CircularProgress from '@mui/material/CircularProgress';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';

const getStatusStyles = (status) => {
  switch (status) {
    case 'Signed':
      return { bgcolor: '#EAD6F5', color: '#8E24AA' };
    case 'Pending':
      return { bgcolor: '#F5E6C8', color: '#A66A00' };
    case 'Approved':
      return { bgcolor: '#D7F2E3', color: '#1B7F5E' };
    default:
      return { bgcolor: '#B0B5BD', color: '#374151' };
  }
};

const formatDate = (dateString) => {
  if (!dateString) return 'Unknown date';

  const date = new Date(dateString.replace(' ', 'T'));

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${hours}:${minutes}:${seconds} ${day}-${month}-${year}`;
};
const DocumentHub = ({
  isFromBuyerSolicitor = false,
  isFileView = false,
  isFromVendorSolicitor = false,
  isDialog = false,
  isVendorContainer = false,
  overrideBuyerId,
  onBack,
  propertyAddress,
  userType,
  buyerId,
  onSelectDocument,
  isDirectBuyerDocumentHistory,
  backToContract,
  propertyIdbanner,
  getListInfo,
  selectedeta,
  statustext,
  ...props
}) => {
  const context = useContext(datacontext);
  const contextt = useContext(datacontextsoli);
  const params = useParams();
  const propertyId = propertyIdbanner
    ? propertyIdbanner
    : userType == 'Buyer'
    ? params?.propertyId
    : params?.dashboardId || props?.propertyId;
  const setIsOpenFileManager =
    context?.setIsOpenFileManager || props.setIsOpenFileManager;
  const [openUploadPopup, setOpenUploadPopup] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedDocData, setSelectedDocData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDocumentHistory, setOpenDocumentHistory] = useState(false);
  const [selectedDocName, setSelectedDocName] = useState('');
  const [selectedDocDetails, setSelectedDocDetails] = useState(null);
  const [refreshHistory, setRefreshHistory] = useState(false);
  const realTimeLog = context?.realTimeLog ?? contextt?.realTimeLog;
  const [documentTypes, setDocumentTypes] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const fetchFileManager = async ({
    propertyId,
    isDialog = false,
    userType,
    buyerId,
  }) => {
    try {
      const payload = {
        propertyId: propertyId,
        buyerId:
          overrideBuyerId != undefined
            ? overrideBuyerId
            : isDialog
            ? buyerId
            : isFromBuyerSolicitor
            ? buyerId
            : 0,
        userType: userType,
      };

      const response = await getApiCall(GET_FILE_MANAGER, payload);
      const apiData = response?.data;

      if (
        apiData?.status === 1 &&
        apiData?.files &&
        apiData?.files?.length > 0
      ) {
        const data = apiData.files;

        return data.map((item) => ({
          title: item?.fileType,
          fileTypeCode: item?.fileTypeCode,
          updated: formatDate(item?.fileCreatedAt),
          user: item?.updatedAs,
          updatedAs: item?.updatedAs,
          status: item?.status
            ? item.status.charAt(0).toUpperCase() +
              item.status.slice(1).toLowerCase()
            : null,
          fileId: item?.fileId,
          filePath: item?.filePath,
          version: item?.version,
          updatedBy: item?.updatedBy,
          buyerId: item?.buyerId,
          updatedByName: item?.updatedByName,
          updatedByNameInitial: item?.updatedByNameInitial,
          description: item?.description,
          approvedByName: item?.approvedByName,
          approvedByNameInitial: item?.approvedByNameInitial,
          approvedAt: item?.approvedAt,
          updatedByProfile: item?.updatedByProfile,
          approvedByProfile: item?.approvedByProfile,
          fileCreatedAt: item?.fileCreatedAt,
          activityStatus: item?.activityStatus,
          activityAs: item?.activityAs,
        }));
      } else if (apiData?.status === -1) {
        return [];
      } else {
        setError('Failed to fetch documents');
        return [];
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      setError('Failed to fetch documents. Please try again.');
      return [];
    }
  };

  const fetchDocumentTypes = async () => {
    try {
      const response = await getApiCall(DOCUMENT_TYPE_LIST, {
        userType,
      });

      if (response?.data?.status === 1) {
        setDocumentTypes(response?.data?.documentType || []);
      }
    } catch (error) {
      console.error('DOCUMENT TYPE LIST ERROR', error);
    }
  };
  const loadDocuments = async (showLoader = true) => {
    if (showLoader) {
      setLoading(true);
    }
    setError(null);

    try {
      const docs = await fetchFileManager({
        propertyId,
        isDialog,
        userType: userType,
        buyerId,
      });
      setDocuments(docs);
    } catch (err) {
      console.error('Error in loadDocuments:', err);
      setError('Failed to load documents. Please try again.');
      setDocuments([]);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (propertyId && !isDialog) {
      loadDocuments(true);
    } else if (!propertyId) {
      setLoading(false);
    }
  }, [propertyId, userType]);

  useEffect(() => {
    if (propertyId && isDialog) {
      loadDocuments(true);
    } else if (!propertyId && isDialog) {
      setLoading(false);
    }
  }, [isDialog, buyerId]);

  useEffect(() => {
    if (isDirectBuyerDocumentHistory && documents.length > 0 && !loading) {
      const getTrimmedTitle = (title) => {
        if (!title) return '';
        const lastDashIndex = title.lastIndexOf('-');
        return lastDashIndex !== -1
          ? title.substring(0, lastDashIndex).trim()
          : title;
      };

      const normalize = (str) => str?.toLowerCase().trim();

      const contractDoc = documents.find(
        (doc) =>
          normalize(getTrimmedTitle(doc.title)) ===
          normalize('Contract of Sale')
      );

      if (contractDoc) {
        setSelectedDocName(contractDoc.title);
        setSelectedDocDetails(contractDoc);
        setOpenDocumentHistory(true);
      }
    }
  }, [isDirectBuyerDocumentHistory, documents, loading]);

  useEffect(() => {
    if (isDialog && isFromVendorSolicitor && documents.length > 0 && !loading) {
      const getTrimmedTitle = (title) => {
        if (!title) return '';
        const lastDashIndex = title.lastIndexOf('-');
        return lastDashIndex !== -1
          ? title.substring(0, lastDashIndex).trim()
          : title;
      };

      const normalize = (str) => str?.toLowerCase().trim();

      const contractDoc = documents.find(
        (doc) =>
          normalize(getTrimmedTitle(doc.title)) ===
          normalize('Contract of Sale')
      );

      if (contractDoc) {
        setSelectedDocName(contractDoc.title);
        setSelectedDocDetails(contractDoc);
        setOpenDocumentHistory(true);
      }
    }
  }, [documents, isDialog, isFromVendorSolicitor, loading]);

  useEffect(() => {
    loadDocuments(false);

    if (getListInfo) {
      getListInfo();
    }
  }, [realTimeLog]);

  useEffect(() => {
    fetchDocumentTypes();
  }, [userType]);
  const handleSelect = (doc) => {
    if (isDialog) {
      if (selectedDoc == doc.fileId) {
        setSelectedDoc(null);
        setSelectedDocData(null);
      } else {
        setSelectedDoc(doc.fileId);
        setSelectedDocData(doc);
      }
    }
  };

  const handleUploadSuccess = () => {
    loadDocuments(false);
    setRefreshHistory((prev) => !prev);
  };

  const handleDocumentClick = (doc) => {
    if (!isDialog) {
      setSelectedDocName(doc.title);
      setSelectedDocDetails(doc);
      setOpenDocumentHistory(true);
    }
  };

  const handleSubmit = async () => {
    if (selectedDocData && onSelectDocument) {
      try {
        setSubmitLoading(true);

        await new Promise((resolve) => setTimeout(resolve, 300));

        onSelectDocument(selectedDocData);
      } catch (error) {
        console.error('Submit Error:', error);
      }
    }
  };

  const handleClose = () => {
    if (onBack) {
      onBack();
    } else {
      setIsOpenFileManager(false);
    }
  };

  const [uploadSourceDocType, setUploadSourceDocType] = useState(null);

  const handleUploadClick = () => {
    setUploadSourceDocType(selectedDocName);
    setOpenUploadPopup(true);
  };

  const handleUploadNavigation = (isSameType) => {
    if (!isSameType) {
      setOpenDocumentHistory(false);
    }
  };

  const CircularProgressWithProfileVendor = (props) => {
    return (
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          width: 43,
          height: 43,
        }}
      >
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          {props.profileImage == '' || props.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                fontSize: '15px',
                backgroundColor: '#666666',
              }}
            >
              {props?.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props?.name}
              src={props.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Box>
      </Box>
    );
  };
  // function to identify and hide upload button in version history page
  const normalizedSelectedDoc = selectedDocName
    ?.split('-')[0]
    ?.trim()
    ?.toLowerCase();

  const isVendorSolicitor = userType?.toLowerCase() === 'vendor solicitor';
  const isS66W = normalizedSelectedDoc === 's66w certificate';

  const showUploadButton =
    (!openDocumentHistory ||
      documentTypes.some(
        (item) =>
          item.documentType?.trim()?.toLowerCase() === normalizedSelectedDoc
      )) &&
    !(openDocumentHistory && isVendorSolicitor && isS66W);
  return (
    <>
      <Box
        sx={{
          ...styles.root,
          padding:
            isDialog || isFromBuyerSolicitor || isFromVendorSolicitor
              ? '24px'
              : '0px',
          display: 'flex',
          flexDirection: 'column',
          ...(isDialog || isFromBuyerSolicitor || isFromVendorSolicitor
            ? {
                flex: 1,
                minHeight: 0,
              }
            : {
                flex: 1,
                minHeight: 0,
              }),
        }}
      >
        {isDialog && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mb: 1,
            }}
          >
            <CloseIcon
              onClick={handleClose}
              sx={{
                cursor: 'pointer',
                fontSize: 22,
                color: '#6B7280',
                '&:hover': { color: '#111827' },
              }}
            />
          </Box>
        )}

        {!openDocumentHistory && (
          <Box
            sx={styles.backWrapper}
            onClick={() => {
              if (onBack) {
                onBack();
              } else {
                setIsOpenFileManager(false);
              }
            }}
          >
            <ArrowBackIcon sx={styles.backIcon} />
            <Typography sx={styles.backText}>Back to Previous</Typography>
          </Box>
        )}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Location sx={styles.homeIcon} width={20} height={20} />
            <Typography sx={styles.headerTitle}>{propertyAddress}</Typography>
          </Stack>
          {showUploadButton && (
            <Button
              variant="contained"
              sx={styles.uploadBtn}
              onClick={handleUploadClick}
            >
              Upload
            </Button>
          )}
        </Stack>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
          }}
        >
          {!openDocumentHistory ? (
            <>
              {/* <Typography sx={styles.sectionTitle}>Documents</Typography> */}

              <Box
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  minHeight: 0,
                  overscrollBehavior: isDialog && 'contain',
                }}
              >
                <Stack spacing={2}>
                  {loading ? (
                    <Box
                      sx={{ display: 'flex', justifyContent: 'center', py: 4 }}
                    >
                      <img
                        alt="Loading"
                        src={Loading}
                        className="loaderImage"
                        style={{
                          height: '50px',
                          width: '50px',
                        }}
                      />
                    </Box>
                  ) : error ? (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        color: 'error.main',
                        textAlign: 'center',
                      }}
                    >
                      {error}
                    </Typography>
                  ) : documents.length === 0 ? (
                    <Typography
                      sx={{ fontFamily: 'Poppins', textAlign: 'center', py: 4 }}
                    >
                      Files not found.
                    </Typography>
                  ) : (
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: '100%',
                        overflowX: 'auto',
                      }}
                    >
                      <Table
                        sx={{
                          minWidth: 1200,
                          tableLayout: 'auto',
                        }}
                      >
                        {/* ---------------- HEADER ---------------- */}
                        <TableHead>
                          <TableRow sx={{ backgroundColor: '#F1F5F9' }}>
                            {isDialog && <TableCell sx={{ minWidth: 50 }} />}

                            {[
                              '  Type',
                              'Activity',
                              'Uploaded By',
                              'Approved By',
                              'Document Status',
                              ...(!isDialog ? ['Description'] : []),
                            ].map((head) => (
                              <TableCell
                                key={head}
                                sx={{
                                  ...poppins600,
                                  fontSize: '14px',
                                  padding: '8px 16px',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {head}
                              </TableCell>
                            ))}

                            {!isDialog && (
                              <TableCell
                                align="center"
                                sx={{
                                  ...poppins500,
                                  fontSize: '14px',
                                  padding: '8px 16px',
                                  minWidth: 80,
                                }}
                              >
                                Action
                              </TableCell>
                            )}
                          </TableRow>
                        </TableHead>

                        {/* ---------------- BODY ---------------- */}
                        <TableBody>
                          {documents.map((doc, index) => {
                            const normalizedTitle = doc.title
                              ?.split('-')[0]
                              ?.trim()
                              ?.toLowerCase();

                            const normalizedUpdatedAs = doc.updatedAs
                              ?.trim()
                              ?.toLowerCase();

                            const normalizedStatus = doc.status
                              ?.trim()
                              ?.toLowerCase();

                            const isContractOfSale =
                              normalizedTitle === 'contract of sale';

                            const isNotContractOfSale = !isContractOfSale;

                            const isSuperseded =
                              isContractOfSale &&
                              normalizedStatus === 'superseded';

                            const isSameVendorSignedContract =
                              isVendorContainer &&
                              isContractOfSale &&
                              normalizedUpdatedAs === 'vendor' &&
                              normalizedStatus === 'signed';

                            const isSameBuyerSignedContract =
                              !isVendorContainer &&
                              isContractOfSale &&
                              normalizedUpdatedAs === 'buyer' &&
                              normalizedStatus === 'signed' &&
                              Number(doc.buyerId) === Number(buyerId);

                            const isDisabled =
                              isDialog &&
                              (isNotContractOfSale ||
                                isSuperseded ||
                                isSameVendorSignedContract ||
                                isSameBuyerSignedContract);

                            const userCellWrapper = {
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                              gap: '2px',
                            };

                            const userRow = {
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                            };

                            const nameText = {
                              ...poppins500,
                              fontSize: '14px',
                              lineHeight: 1.2,
                              whiteSpace: 'nowrap',
                            };

                            const subText = {
                              ...poppins400,
                              fontSize: '12px',
                              color: '#64748B',
                              lineHeight: 1.2,
                              whiteSpace: 'nowrap',
                            };

                            return (
                              <TableRow
                                key={doc.fileId || index}
                                sx={{
                                  opacity: isDisabled ? 0.6 : 1,
                                  cursor: isDisabled
                                    ? 'not-allowed'
                                    : 'pointer',
                                  ...(selectedDoc === doc.fileId && {
                                    backgroundColor: '#F4F1FE',
                                  }),
                                  '&:hover': !isDisabled && {
                                    backgroundColor: '#ECEFF1',
                                  },
                                }}
                                onClick={() => {
                                  if (isDisabled) return;

                                  if (isDialog) {
                                    handleSelect(doc);
                                  } else {
                                    handleDocumentClick(doc);
                                  }
                                }}
                              >
                                {/* CHECKBOX */}
                                {isDialog && (
                                  <TableCell sx={{ padding: '8px 16px' }}>
                                    <input
                                      type="checkbox"
                                      checked={selectedDoc === doc.fileId}
                                      disabled={isDisabled}
                                      onChange={() => handleSelect(doc)}
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        cursor: isDisabled
                                          ? 'not-allowed'
                                          : 'pointer',
                                      }}
                                    />
                                  </TableCell>
                                )}

                                {/* DOCUMENT */}
                                <TableCell
                                  sx={{ padding: '8px 16px', minWidth: 200 }}
                                >
                                  <Typography sx={nameText}>
                                    {doc.title}
                                  </Typography>
                                </TableCell>

                                {/* ACTIVITY */}
                                <TableCell
                                  sx={{ padding: '8px 16px', minWidth: 140 }}
                                >
                                  <Box sx={userCellWrapper}>
                                    <Typography sx={nameText}>
                                      {doc?.activityStatus || '-'}
                                    </Typography>
                                    <Typography sx={subText}>
                                      {doc.activityAs || '-'}
                                    </Typography>
                                  </Box>
                                </TableCell>

                                {/* UPLOADED BY */}
                                <TableCell
                                  sx={{ padding: '8px 16px', minWidth: 180 }}
                                >
                                  <Box sx={userCellWrapper}>
                                    <Box sx={userRow}>
                                      <CircularProgressWithProfileVendor
                                        value={''}
                                        name={doc?.updatedByNameInitial}
                                        profileImage={
                                          doc?.updatedByProfile || ''
                                        }
                                      />
                                      <Typography sx={nameText}>
                                        {doc.updatedByName || '-'}
                                      </Typography>
                                    </Box>

                                    <Typography sx={subText}>
                                      {doc.fileCreatedAt
                                        ? formatDate(doc.fileCreatedAt)
                                        : '-'}
                                    </Typography>
                                  </Box>
                                </TableCell>

                                {/* APPROVED BY */}
                                <TableCell
                                  sx={{ padding: '8px 16px', minWidth: 180 }}
                                >
                                  {doc?.approvedByName ? (
                                    <Box sx={userCellWrapper}>
                                      <Box sx={userRow}>
                                        <CircularProgressWithProfileVendor
                                          value={''}
                                          name={doc?.approvedByNameInitial}
                                          profileImage={
                                            doc?.approvedByProfile || ''
                                          }
                                        />

                                        <Typography sx={nameText}>
                                          {doc.approvedByName}
                                        </Typography>
                                      </Box>

                                      <Typography sx={subText}>
                                        {doc?.approvedAt
                                          ? formatDate(doc.approvedAt)
                                          : '-'}
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Typography sx={nameText}>-</Typography>
                                  )}
                                </TableCell>

                                {/* STATUS */}
                                <TableCell
                                  sx={{ padding: '8px 16px', minWidth: 150 }}
                                >
                                  {doc.status ? (
                                    <Chip
                                      label={doc.status}
                                      sx={{
                                        ...styles.chip,
                                        ...getStatusStyles(doc.status),
                                      }}
                                    />
                                  ) : (
                                    <Typography sx={nameText}>-</Typography>
                                  )}
                                </TableCell>

                                {/* DESCRIPTION */}
                                {!isDialog && (
                                  <TableCell
                                    sx={{ padding: '8px 16px', minWidth: 220 }}
                                  >
                                    <Typography
                                      sx={{
                                        ...poppins400,
                                        fontSize: '14px',
                                        wordBreak: 'break-word',
                                      }}
                                    >
                                      {doc.description || '-'}
                                    </Typography>
                                  </TableCell>
                                )}
                                {/* ACTION */}
                                {!isDialog && (
                                  <TableCell
                                    sx={{ padding: '8px 16px', minWidth: 80 }}
                                    align="center"
                                  >
                                    <Tooltip
                                      title="View"
                                      arrow
                                      placement="top"
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            fontFamily: 'Poppins',
                                            fontSize: '12px',
                                            fontWeight: 400,
                                          },
                                        },
                                      }}
                                      PopperProps={{
                                        disablePortal: false,
                                        sx: {
                                          zIndex: 1500,
                                        },
                                      }}
                                    >
                                      <IconButton
                                        sx={{
                                          color: 'inherit',
                                          '&:hover': {
                                            color: '#1976d2',
                                          },
                                        }}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          setSelectedDocName(doc.title);
                                          setOpenDocumentHistory(true);
                                        }}
                                      >
                                        <ChevronRightIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Stack>
              </Box>
              {isDialog && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 1.5,
                    pt: 2,
                    borderTop: '1px solid #E5E7EB',
                    backgroundColor: '#fff',
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      fontFamily: 'Poppins',
                      textTransform: 'none',
                      backgroundColor: '#4CA4D6',
                      borderRadius: '6px',
                      px: 3,
                      fontWeight: 500,
                      '&:hover': {
                        backgroundColor: '#3a8bb8',
                      },
                    }}
                    disabled={!selectedDoc || submitLoading}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                  {submitLoading && (
                    <img
                      alt="Loading"
                      src={Loading}
                      className="loaderImage"
                      style={{
                        height: '25px',
                        width: '25px',
                      }}
                    />
                  )}
                </Box>
              )}
            </>
          ) : (
            <Box
              sx={{
                flex: 1,
                overflowY: 'auto',
                minHeight: 0,
              }}
            >
              <DocumentHistory
                isDialog={false}
                onBackClick={() => setOpenDocumentHistory(false)}
                propertyId={propertyId}
                buyerId={selectedDocDetails?.buyerId}
                userType={userType}
                fileType={selectedDocName}
                isFromVendorSolicitor={isFromVendorSolicitor}
                isFromBuyerSolicitor={isFromBuyerSolicitor}
                address={propertyAddress}
                isDirectBuyerDocumentHistory={isDirectBuyerDocumentHistory}
                backToContract={backToContract}
                fileTypeCode={selectedDocDetails?.fileTypeCode}
                fileId={selectedDocDetails?.fileId}
                refreshTrigger={refreshHistory}
                getListInfo={getListInfo}
              />
            </Box>
          )}
        </Box>
      </Box>

      <FilesUploadPopup
        open={openUploadPopup}
        handleClose={() => setOpenUploadPopup(false)}
        documentType={selectedDocName}
        sourceDocumentType={uploadSourceDocType}
        onUploadNavigate={handleUploadNavigation}
        propertyId={propertyId}
        buyerId={
          openDocumentHistory && selectedDocDetails?.buyerId
            ? selectedDocDetails.buyerId
            : buyerId
        }
        userType={userType}
        onUploadSuccess={handleUploadSuccess}
        isDialog={isDialog}
        shouldPrefill={openDocumentHistory}
        selectedeta={selectedeta}
        statustext={statustext}
        address={propertyAddress}
        isFileView={isFileView}
      />
    </>
  );
};

export default DocumentHub;

const fontFamily = 'Poppins';

export const styles = {
  root: {
    fontFamily,
  },

  backWrapper: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  backIcon: {
    fontSize: 18,
    mr: 1,
  },

  backText: {
    fontFamily,
    fontSize: '14px',
    fontWeight: 500,
    color: '#6F61E1',
  },

  homeIcon: {
    color: '#888',
  },

  headerTitle: {
    fontFamily,
    fontSize: '18px',
    fontWeight: 600,
  },

  uploadBtn: {
    fontFamily,
    textTransform: 'none',
    backgroundColor: '#4CA4D6',
    borderRadius: '6px',
    px: 3,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#3a8bb8',
    },
  },

  sectionTitle: {
    fontFamily,
    fontSize: '16px',
    fontWeight: 600,
    mb: 2,
  },

  card: {
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F3F4F6',
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ECEFF1',
    },
  },

  docTitle: {
    fontFamily,
    fontSize: '14px',
    fontWeight: 600,
    display: 'block',
    mb: '2px',
  },

  docSub: {
    fontFamily,
    fontSize: '13px',
    color: '#888',
    display: 'block',
  },

  chip: {
    fontFamily,
    fontSize: '12px',
    fontWeight: 500,
    borderRadius: '6px',
    height: '28px',
    minWidth: '90px',
    justifyContent: 'center',
    '& .MuiChip-label': {
      px: 1,
      width: '100%',
      textAlign: 'center',
    },
  },

  arrow: {
    color: '#999',
  },
};
